import { Button } from '@cencosud-cencommerce/paris-uikit';

import { addToCartMock } from '@/modules/shared/infrastructure/mocks/addToCart';

export const AddToCartButton = () => {
  const handleClick = async () => {
    await addToCartMock();
  };
  return <Button onClick={handleClick}>Añadir Producto</Button>;
};
